import React from 'react';
import { Grant } from 'shared/redux/product/ProductTypes';
import DashboardCard from './DashboardStatsCard';
import { getStatsCardBrokers } from '../../../utils/helpers';

interface OptOutRequestsCardProps {
  optOutsSubmitted: number;
  pendingCount: number;
  grant: Grant | undefined;
}

const OptOutRequestsCard: React.FC<OptOutRequestsCardProps> = ({
  optOutsSubmitted,
  pendingCount,
  grant,
}) => {

  const total_brokers = grant? getStatsCardBrokers(grant, 'optout') : 400
  const progress = (optOutsSubmitted / total_brokers) * 100;
  const displayPending = optOutsSubmitted === 0 ? `${total_brokers}+` : pendingCount;

  return (
    <DashboardCard
      heading="Expanded Coverage Progress"
      tooltipText="This section shows how many opt out requests have been submitted to data brokers on your behalf. Pending requests are either currently being sent or were not covered under your subscription plan."
      mainStatValue={optOutsSubmitted}
      mainStatLabel="Optout Requests Submitted"
      progress={progress}
      leftStat={{ label: 'Requests Pending', value: displayPending, barColor: '#7459D9' }}
      rightStat={{ label: 'Brokers Covered', value: `${total_brokers}+`, barColor: '#7459D980' }}
    />
  );
};

export default OptOutRequestsCard;
